import { useSelector } from 'react-redux'
import { selectRegions } from '@/features/domain/region'

export const useHasRegions = () => {
  const regions = useSelector(selectRegions)

  return Object.keys(regions).length > 0
}
